import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideMonitor = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <rect width={20} height={14} x={2} y={3} rx={2} />
      <path d="M8 21h8m-4-4v4" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideMonitor);
const Memo = memo(ForwardRef);
export default Memo;
